export enum AmountAggregatorUpdateFrequency {
PerFiscalYear,
Manually,
}
